import { render, staticRenderFns } from "./DescriptionAssuranceHabitation.vue?vue&type=template&id=f018caf8&scoped=true"
import script from "./DescriptionAssuranceHabitation.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceHabitation.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceHabitation.vue?vue&type=style&index=0&id=f018caf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018caf8",
  null
  
)

export default component.exports